const BootImage = ({
  margin = "2",
  type = "rounded-circle",
  padding = "2",
  src,
  children,
}) => {
 
  return (
    <>
      <div className="position-relative d-inline-block">
        <img
          src={src}
          className={`${type} m-${margin} p-${padding}  shadow img-fluid`}
          style={{ width: "200px", height: "100px", objectFit: "cover" }}
        ></img>
        {children}
      </div>
    </>
  );
};

export default BootImage;
